export default __webpack_public_path__ + "static/media/2.8e7c8db9.svg";